// react components
import React from 'react'

// data
import {
    contentTypeModelTypeSite,
} from 'data'

// pages
import {
    DetailField825,
} from 'pages'

// serializers
import {
    ContentTypeDetailBlockFieldSetTypes,
    ContentTypeSettingsTypes,
    ContentTypeSettingsCustomTypes,
} from 'serializers/site'

// props
type DetailFieldSet825Props = {
    blockId: number
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    contentTypeSettingsCustom: ContentTypeSettingsCustomTypes | undefined
    fieldSetObject: ContentTypeDetailBlockFieldSetTypes
    object: any
    subContentTypeForced?: { id: number, name: string }
}

// main
export const DetailFieldSet825: React.FC<DetailFieldSet825Props> = React.memo(({
    blockId,
    contentType,
    contentTypeSettings,
    contentTypeSettingsCustom,
    fieldSetObject,
    object,
    subContentTypeForced,
}) => {

    if (fieldSetObject.hideIfNotSuperuser) return null

    return (
        <div className={`detail-component-field-set-825 ${blockId}`}>
            <div className='dcfs-fieldsets'>
                <div className='dcfs-fieldsets-header'>
                    <div className='dcfs-wrap-title'>
                        <p className='dcfs-title'>{fieldSetObject.title}</p>
                    </div>
                </div>
                {fieldSetObject.fields?.map((val) => (
                    <DetailField825
                        key={val}
                        contentType={contentType}
                        contentTypeSettings={contentTypeSettings}
                        contentTypeSettingsCustom={contentTypeSettingsCustom}
                        field={val}
                        fieldSetObject={fieldSetObject}
                        object={object}
                        subContentTypeForced={subContentTypeForced}
                    />
                ))}
            </div>
        </div>
    )
})
